import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({ dateRange, userType, region, onFilterChange }) => {
  const dateRangeOptions = [
    { value: '7days', label: '7 derniers jours' },
    { value: '30days', label: '30 derniers jours' },
    { value: '90days', label: '90 derniers jours' },
    { value: '6months', label: '6 derniers mois' },
    { value: '1year', label: '1 an' },
    { value: 'custom', label: 'Période personnalisée' }
  ];

  const userTypeOptions = [
    { value: 'all', label: 'Tous les utilisateurs' },
    { value: 'students', label: 'Étudiants' },
    { value: 'parents', label: 'Parents' },
    { value: 'counselors', label: 'Conseillers' }
  ];

  const regionOptions = [
    { value: 'all', label: 'Toutes les régions' },
    { value: 'dakar', label: 'Dakar' },
    { value: 'thies', label: 'Thiès' },
    { value: 'saint-louis', label: 'Saint-Louis' },
    { value: 'kaolack', label: 'Kaolack' },
    { value: 'ziguinchor', label: 'Ziguinchor' },
    { value: 'other', label: 'Autres régions' }
  ];

  const handleReset = () => {
    onFilterChange('dateRange', '30days');
    onFilterChange('userType', 'all');
    onFilterChange('region', 'all');
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6 mb-6 shadow-sm">
      <div className="flex items-center gap-3 mb-4">
        <Icon name="SlidersHorizontal" size={24} className="text-primary" />
        <h2 className="text-lg md:text-xl font-semibold text-foreground">
          Filtres de Données
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <Select
          label="Période"
          options={dateRangeOptions}
          value={dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
          placeholder="Sélectionner une période"
        />
        <Select
          label="Type d'utilisateur"
          options={userTypeOptions}
          value={userType}
          onChange={(value) => onFilterChange('userType', value)}
          placeholder="Sélectionner un type"
        />
        <Select
          label="Région géographique"
          options={regionOptions}
          value={region}
          onChange={(value) => onFilterChange('region', value)}
          placeholder="Sélectionner une région"
        />
      </div>
      <div className="flex justify-end">
        <Button
          variant="outline"
          iconName="RotateCcw"
          onClick={handleReset}
          size="sm"
        >
          Réinitialiser les filtres
        </Button>
      </div>
    </div>
  );
};

export default FilterPanel;